var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_2740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6649 12.3234L13.752 6.06253C14.5842 3.56587 15.0003 2.31754 14.3414 1.65859C13.6824 0.999636 12.434 1.41575 9.93725 2.24797L3.71643 4.32149C2.32855 4.7841 1.63461 5.01541 1.42397 5.52429C1.37447 5.64389 1.34453 5.77068 1.33532 5.89979C1.29614 6.44914 1.81337 6.96636 2.84784 8.00078L3.03626 8.1892C3.20606 8.35899 3.29095 8.44388 3.35513 8.53839C3.48171 8.72477 3.55356 8.94288 3.56254 9.168C3.56709 9.28214 3.54927 9.40087 3.51363 9.63834C3.38317 10.5075 3.31794 10.9421 3.39478 11.2765C3.54795 11.9431 4.06391 12.4664 4.7283 12.6289C5.06162 12.7104 5.49709 12.6513 6.36805 12.5331L6.41567 12.5267C6.66119 12.4934 6.78396 12.4767 6.90183 12.4838C7.1158 12.4967 7.32247 12.5664 7.50056 12.6857C7.59867 12.7514 7.68627 12.839 7.86147 13.0142L8.02898 13.1817C9.03583 14.1885 9.53926 14.692 10.0733 14.6657C10.2205 14.6585 10.3652 14.6244 10.5001 14.565C10.9895 14.3496 11.2146 13.6742 11.6649 12.3234Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12L14 2",
    stroke: "currentColor",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_2740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.439a4049e47ca370e5eaf8a01be4228f.svg";
export { ForwardRef as ReactComponent };